/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { FC, Fragment, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Headline, Body } from '@airwallex/typography';
import { space } from '@airwallex/global';
import Button from '@airwallex/button';
import { useHistory } from 'react-router-dom';

import SomethingWrong from '@/assets/svgs/somethingWrong.svg';
import Header from '@/components/header';
import { useMobile } from '@/hooks/useMediaQuery';
import { event, Category, Action } from '@/utils/analytics/google';

import { TopBox, ImageWrapper, Content } from './style';

export interface ErrorWithButtonProps {
  image?: JSX.Element;
  title?: ReactNode;
  body?: ReactNode;
  buttonText?: ReactNode;
  onClick?: () => void;
}

const ErrorWithButton: FC<ErrorWithButtonProps> = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const isMobile = useMobile();
  const {
    image = <SomethingWrong />,
    title = t('checkout.error.something_went_wrong'),
    body = t('checkout.error.reload_page'),
    buttonText = t('checkout.error.button.reload_page'),
    onClick = () => history.goBack(),
  } = props;

  const handleClick = () => {
    onClick();
    event(Category.PaymentFailPage, Action.Click, String(title));
  };

  return (
    <Fragment>
      <Header isMobile={isMobile} haveLanguageChoice hideBorder={!isMobile} />
      <TopBox
        css={css`
          margin-top: ${space.l};
        `}
      >
        <ImageWrapper>{image}</ImageWrapper>
      </TopBox>
      <Content>
        <Headline
          css={css`
            margin-top: ${space.xxxl};
          `}
        >
          {title}
        </Headline>
        <Body
          variant="100"
          css={css`
            margin-top: ${space.s};
          `}
        >
          {body}
        </Body>
        <Button
          variant="PRIMARY"
          css={css`
            margin-top: ${space.xxl};
          `}
          onClick={handleClick}
        >
          {buttonText}
        </Button>
      </Content>
    </Fragment>
  );
};

export default ErrorWithButton;
